export default "__VITE_ASSET__DcHFsHUm__"